import { render, staticRenderFns } from "./AcceptanceAttachmentDetails.vue?vue&type=template&id=ba5aec7a&"
import script from "./AcceptanceAttachmentDetails.vue?vue&type=script&lang=js&"
export * from "./AcceptanceAttachmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports